import { SchemaTypesUtil } from '@axiom/types';

export const FormSchemaUtil = {
  findNode: (schema: SchemaDefinition, propPath: string) => {
    const parts = propPath.split('.');
    let current: SchemaDefinitionProperty = schema;

    for (const part of parts) {
      if (!Number.isNaN(+part)) {
        if (!current.arrayType) {
          throw new Error(`Unknown property: ${propPath}`);
        }
        current = current.arrayType;
      } else if (current.children?.[part] !== undefined) {
        current = current.children[part];
      } else if (current.recordType) {
        current = current.recordType;
      } else {
        throw new Error(`Unknown property: ${propPath}`);
      }
    }

    return current;
  },
  getRoot: (schema: ZodMergedType) => {
    return schema._def as { typeName: string };
  },
  isObjectSchema: (schema: ZodMergedType) => {
    return FormSchemaUtil.getRoot(schema).typeName === 'ZodObject';
  },
  isArraySchema: (schema: ZodMergedType) => {
    return FormSchemaUtil.getRoot(schema).typeName === 'ZodArray';
  },
  validate: (schema: ZodMergedType, formData: unknown) => {
    return SchemaTypesUtil.validate(schema, formData);
  },
};
